import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Button } from 'js/design_system/Button';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _Container from "PodcastLibraryAd1-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=Container";
import _ContentWrapper from "PodcastLibraryAd1-ContentWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=ContentWrapper";
import _ImageSection from "PodcastLibraryAd1-ImageSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=ImageSection";
import _AudioPlayer from "PodcastLibraryAd1-AudioPlayer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=AudioPlayer";
import _IconWrapper from "PodcastLibraryAd1-IconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=IconWrapper";
import _GrayIconWrapper from "PodcastLibraryAd1-GrayIconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=GrayIconWrapper";
import _TimeText from "PodcastLibraryAd1-TimeText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=TimeText";
import _Timeline from "PodcastLibraryAd1-Timeline.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=Timeline";
import _TextSection from "PodcastLibraryAd1-TextSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=TextSection";
import _TextContent from "PodcastLibraryAd1-TextContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=TextContent";
import _ButtonWrapper from "PodcastLibraryAd1-ButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=ButtonWrapper";
import _Title from "PodcastLibraryAd1-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=Title";
import _Description from "PodcastLibraryAd1-Description.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=Description";
import _StyledButton from "PodcastLibraryAd1-StyledButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd1.tsx?styleId=StyledButton";


const Container = /*#__PURE__*/styled("a", null, {
  displayName: "Container",
  styles: _Container
});

const ContentWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper
});

const ImageSection = /*#__PURE__*/styled("div", null, {
  displayName: "ImageSection",
  styles: _ImageSection
});

const AudioPlayer = /*#__PURE__*/styled("div", null, {
  displayName: "AudioPlayer",
  styles: _AudioPlayer
});

const IconWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
});

const GrayIconWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "GrayIconWrapper",
  styles: _GrayIconWrapper
});

const TimeText = /*#__PURE__*/styled("p", null, {
  displayName: "TimeText",
  styles: _TimeText
});

const Timeline = /*#__PURE__*/styled("div", null, {
  displayName: "Timeline",
  styles: _Timeline
});

const TextSection = /*#__PURE__*/styled("div", null, {
  displayName: "TextSection",
  styles: _TextSection
});

const TextContent = /*#__PURE__*/styled("div", null, {
  displayName: "TextContent",
  styles: _TextContent
});

const ButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
});

const Title = /*#__PURE__*/styled("p", null, {
  displayName: "Title",
  styles: _Title
});

const Description = /*#__PURE__*/styled("p", null, {
  displayName: "Description",
  styles: _Description
});

const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton
});

/**
 * Podcast Library Ad component that promotes the podcast library feature.
 * Displays as a clickable card in the home feed linking to the podcast library.
 *
 * This component is automatically tracked with impression watching.
 */
export const PodcastLibraryAd1: React.FC = () => {
  const impressionSource = 'podcast_lib.home.ad-1';

  return (
    <ImpressionWatcher active={true} source={impressionSource}>
      <Container href={routes.podcast_library_url()}>
        <ContentWrapper>
          <ImageSection>
            <AudioPlayer>
              <IconWrapper>
                <Icon name="play_arrow" size={22} />
              </IconWrapper>
              <TimeText>0:00/ 4:45</TimeText>
              <Timeline />
              <GrayIconWrapper>
                <Icon name="volume_up" size={22} />
              </GrayIconWrapper>
            </AudioPlayer>
          </ImageSection>
          <TextSection>
            <TextContent>
              <Title>Discover 35K+ research podcasts</Title>
              <Description>
                Explore research podcasts in Mathematics, Algebra and Abelian
                groups
              </Description>
            </TextContent>
            <ButtonWrapper>
              <StyledButton size="sm" iconRight="arrow_forward">
                Browse podcast library
              </StyledButton>
            </ButtonWrapper>
          </TextSection>
        </ContentWrapper>
      </Container>
    </ImpressionWatcher>
  );
};
